import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { VideoService } from '../../services/video.service';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { ByteSizePipe } from '../../pipes/byte-size.pipe';

@Component({
  selector: 'app-storage-label',
  templateUrl: './storage-label.component.html',
  styleUrls: ['./storage-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, TranslateModule, ByteSizePipe]
})
export class StorageLabelComponent {
  videoService = inject(VideoService);
  authService = inject(AuthService);
  public statistic$ = this.videoService.getStatisticsByClub(this.authService.user.club_id);
}
